import { DbRef } from "./firebase";
import { OperationSource } from "./general";
export var OrderStatus;
(function (OrderStatus) {
    /**
     * Ordering user has canceled all procedures on order
     */
    OrderStatus["CANCELED"] = "canceled";
    /**
     * All prcedures on the Order have been completed
     * NOTE: This is not yet implemented
     */
    OrderStatus["COMPLETE"] = "complete";
    /**
     * Booking requirements have been finalized
     */
    OrderStatus["CREATED"] = "created";
    /**
     * Order initialized and booking requirements have not been finalized
     */
    OrderStatus["DRAFT"] = "draft";
    /**
     * Doctor uploaded a form
     */
    OrderStatus["INCOMPLETE"] = "incomplete";
})(OrderStatus || (OrderStatus = {}));
/** Enum for values other than user ID for `Order.schedulingUserID` */
export var NonIdSchedulingUser;
(function (NonIdSchedulingUser) {
    NonIdSchedulingUser["CONTACT"] = "contact";
})(NonIdSchedulingUser || (NonIdSchedulingUser = {}));
export var Fulfiller;
(function (Fulfiller) {
    Fulfiller["CARESEND"] = "caresend";
    Fulfiller["OFFICE"] = "office";
})(Fulfiller || (Fulfiller = {}));
export var OrderOperationType;
(function (OrderOperationType) {
    OrderOperationType["CANCEL"] = "cancel";
    OrderOperationType["CREATE"] = "create";
    OrderOperationType["UPDATE"] = "update";
})(OrderOperationType || (OrderOperationType = {}));
export const OrderRelationshipKeys = {
    bookings: { ref: DbRef.BOOKINGS },
    createdBy: { ref: DbRef.USERS },
    createdByOfficeID: { ref: DbRef.OFFICES },
    draftWaypoints: { ref: DbRef.DRAFT_WAYPOINTS },
    officeID: { ref: DbRef.OFFICES },
    prescriberID: { ref: DbRef.USERS },
    schedulingUserID: { ref: DbRef.USERS },
    transactions: { ref: DbRef.TRANSACTIONS },
};
export var AlgoliaOrderTag;
(function (AlgoliaOrderTag) {
    AlgoliaOrderTag["IS_FULFILLED"] = "isFulfilled";
})(AlgoliaOrderTag || (AlgoliaOrderTag = {}));
//# sourceMappingURL=order.js.map